import { adminRoutes } from 'app/constants/routes';
import { UserRoles } from 'app/constants/user';
import { RouteBuilderItem } from 'app/routes/routeBuilder';

import {
  BrokerCarrierMatchingDashboard,
  BrokerCarrierMatchingNext,
  BrokerCarrierMatchingShow,
} from './BrokerCarrierMatchingRouteComponents';

const basePath = adminRoutes.brokerCarrierMatchings;

export const brokerCarrierMatchingRoutes: RouteBuilderItem[] = [
  /* eslint-disable @typescript-eslint/naming-convention */
  {
    Component: BrokerCarrierMatchingDashboard,
    path: `${basePath}/dashboard`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: BrokerCarrierMatchingNext,
    path: `${basePath}/next`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  {
    Component: BrokerCarrierMatchingShow,
    path: `${basePath}/:id`,
    permitOnly: [UserRoles.CarrierConnector],
  },
  /* eslint-enable @typescript-eslint/naming-convention */
];
